import script from "./BookCardThumbnail.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookCardThumbnail.vue?vue&type=script&setup=true&lang=ts"

import "./BookCardThumbnail.vue?vue&type=style&index=0&id=458159b7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-458159b7"]])

export default __exports__